import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, } from '@angular/forms';
import { MinhasSolicitacoes } from '../../../../../pages/models/suporte.dto';
import { SuporteService } from '../../../services/suporte.service';
import { AuthService } from '../../../../../services/auth.service';

@Component({
  selector: 'app-suporte',
  standalone: false,
  templateUrl: './suporte.component.html',
  styleUrls: ['./suporte.component.css']
})
export class SuporteComponent implements OnInit {
  suporteForm!: FormGroup;
  selectedFile: File | null = null;
  selectedFileName: string = '';
  previewUrl: string | null = null;
  showList: boolean = false;
  minhasSolicitacoes: MinhasSolicitacoes | null = null;
  displayName: string = '';
  companyName: string = '';
  editMode: boolean = false;
  editingId: string | null = null;

  constructor(private fb: FormBuilder, private suporteService: SuporteService, private authService: AuthService) {}

  ngOnInit(): void {
    this.initForm();
    this.loadUserInfo();
  }

  private loadUserInfo(): void {
    try {
      const u = this.authService.getUsuario();
      if (u) {
        this.displayName = (u.nomeUsuario || u.userName || u.nome || u.user || '') as string;
        this.companyName = (u.nomeEmpresa || u.nomeDaEmpresa || u.company || '') as string;
      }
    } catch (e) {
      // ignore
    }

    if (!this.displayName || !this.companyName) {
      const token = this.authService.getToken() || localStorage.getItem('token');
      if (token) {
        try {
          const payload = this.decodeJwt(token);
          this.displayName = this.displayName || (payload?.nomeUsuario || payload?.userName || payload?.unique_name || '');
          this.companyName = this.companyName || (payload?.nomeEmpresa || payload?.nomeDaEmpresa || '');
        } catch (e) {}
      }
    }
  }

  private decodeJwt(token: string): any {
    try {
      const parts = token.split('.');
      if (parts.length < 2) return null;
      const payload = parts[1];
      const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
      return JSON.parse(decodeURIComponent(Array.prototype.map.call(decoded, (c: string) => '%'+('00'+c.charCodeAt(0).toString(16)).slice(-2)).join('')));
    } catch (e) {
      return null;
    }
  }

  logout(): void {
    try { this.authService.logout(); } catch (e) { console.error('Logout falhou', e); }
  }

  initForm(): void {
    this.suporteForm = this.fb.group({
      titulo: ['', [Validators.required, Validators.minLength(5)]],
      numeroVistoria: ['', [Validators.pattern('^[0-9]+$')]],
      descricao: ['', [Validators.required, Validators.minLength(10)]],
      foto: [null]
    });
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.selectedFile = file;
      this.selectedFileName = file.name;

      // Preview da imagem
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.previewUrl = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }

  removeFile(): void {
    this.selectedFile = null;
    this.selectedFileName = '';
    this.previewUrl = null;
    this.suporteForm.patchValue({ foto: null });
  }

  onSubmit(): void {
    if (this.suporteForm.valid) {
      const payload = {
        titulo: this.suporteForm.get('titulo')?.value,
        descricao: this.suporteForm.get('descricao')?.value,
        numeroVistoria: this.suporteForm.get('numeroVistoria')?.value,
        foto: this.selectedFile || undefined
      };

      if (this.editMode && this.editingId) {
        this.suporteService.atualizarSolicitacao(this.editingId, payload).subscribe({
          next: (res) => {
            console.log('Solicitação atualizada', res);
            this.suporteForm.reset();
            this.removeFile();
            this.editMode = false;
            this.editingId = null;
            this.showMinhasSolicitacoes();
          },
          error: (err) => console.error('Erro ao atualizar solicitação', err)
        });
      } else {
        this.suporteService.enviarSolicitacao(payload).subscribe({
          next: (res) => {
            console.log('Solicitação enviada com sucesso', res);
            this.suporteForm.reset();
            this.removeFile();
            this.showMinhasSolicitacoes();
          },
          error: (err) => {
            console.error('Erro ao enviar solicitação', err);
          }
        });
      }
    }
  }

  showMinhasSolicitacoes(): void {
    this.showList = true;
    this.editMode = false;
    this.editingId = null;
    this.suporteForm.reset();
    this.removeFile();
    this.refreshMinhasSolicitacoes();
  }

  showSolicitar(): void {
    this.showList = false;
    this.editMode = false;
    this.editingId = null;
    this.suporteForm.reset();
    this.removeFile();
  }

  refreshMinhasSolicitacoes(): void {
    this.suporteService.obterMinhasSolicitacoes().subscribe({
      next: (res) => (this.minhasSolicitacoes = res),
      error: (err) => console.error('Erro ao obter solicitações', err)
    });
  }

  cancelarSolicitacao(id: string): void {
    if (!confirm('Deseja cancelar esta solicitação?')) return;
    this.suporteService.atualizarStatus(id, 'CANCELADO').subscribe({
      next: () => this.refreshMinhasSolicitacoes(),
      error: (err) => console.error('Erro ao cancelar', err)
    });
  }

  editSolicitacao(ticket: any): void {
    // only allow editing when status is aberto
    const status = (ticket?.status || '').toString().toLowerCase();
    if (status !== 'aberto') return;

    this.editMode = true;
    this.editingId = ticket.id;
    this.showList = false;
    // populate form
    this.suporteForm.patchValue({
      titulo: ticket.titulo || '',
      descricao: ticket.descricao || '',
      numeroVistoria: ticket.numeroVistoria || ''
    });
    // preview existing image if available
    if (ticket.fotos && ticket.fotos.length) {
      this.previewUrl = ticket.fotos[0].url || null;
      this.selectedFileName = 'Imagem atual';
      this.selectedFile = null;
    } else {
      this.previewUrl = null;
      this.selectedFileName = '';
      this.selectedFile = null;
    }
  }

  get titulo() {
    return this.suporteForm.get('titulo');
  }

  get descricao() {
    return this.suporteForm.get('descricao');
  }

  get numeroVistoria() {
    return this.suporteForm.get('numeroVistoria');
  }
}
